module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "contents"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CKNOWLEDGMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter02"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTRODUCTION")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_vm._v("1. B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EHEMOTH TO")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INOSAUR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter02"
    }
  }, [_vm._v("2. L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OWER")]), _vm._v(", U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPER")]), _vm._v(", M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IDDLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMEN’S")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EAR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RICKS AND")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORTAR")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INDOW")]), _vm._v("-S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HOPPING")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AZZLE")]), _vm._v("-D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AZZLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LOORWALKERS")]), _vm._v(", F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASHIONISTS, AND")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUNDERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" G"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OODS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUR")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ERVICE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HILDREN’S")]), _vm._v(" W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONDERLAND")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ASHIONING THE")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EEN")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARKET")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("VERYTHING FOR THE")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OME")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PILOGUE")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EFERENCES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NDEX OF")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TORES")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/backmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NDEX")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0